module.exports = __webpack_public_path__ + "static/media/kite_surfing.67a6c0de.webp";